/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import _ from "lodash";
import PaymentObligation from "./PaymentObligation/PaymentObligation";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import MenuItem from "@mui/material/MenuItem";
import SubmitButton from "../../Button/SubmitButton";
import { Box, SelectChangeEvent } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const OtherPaymentObligations = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const empty = {
    name: "",
    remainingTerm: "",
    outstandingDebt: "",
    repayment: "",
    petitionerShare: "",
  };

  const initialValues = {
    hasOtherPaymentObligations: pcs.hasOtherPaymentObligations,
    paymentObligations: !_.isEmpty(pcs.paymentObligations) ? pcs.paymentObligations : [empty],
  };

  const { values, handleChange, handleSubmit, errors, touchedValues, handleBlur } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  const add = () => {
    const paymentObligations = values.paymentObligations || [];
    if (paymentObligations.length >= 5) {
      return;
    }

    paymentObligations.push(empty);

    handleChange({
      target: {
        type: "other",
        name: "paymentObligations",
        value: paymentObligations,
      },
    });
  };

  const handleMore = ({ target }: SelectChangeEvent) => {
    const { name, value } = target;
    if (value === "yes") {
      add();
    }
    if (value === "no") {
      const splitName = _.split(name, "-");
      const lastPart = splitName[splitName.length - 1];
      const key = parseInt(lastPart);
      handleChange({
        target: {
          type: "other",
          name: "paymentObligations",
          value: _.slice(values.paymentObligations, 0, key + 1),
        },
      });
    }
  };

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Zahlungsverpflichtungen</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Haben Sie sonstige Zahlungsverpflichtungen oder Kredite, die Sie abbezahlen?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Zahlungsverpflichtung"}
              name={"hasOtherPaymentObligations"}
              value={formValue(values, "hasOtherPaymentObligations")}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          {formValue(values, "hasOtherPaymentObligations") === "yes" && (
            <>
              {_.map(values.paymentObligations, (paymentObligation, key) => (
                <React.Fragment key={key}>
                  <PaymentObligation
                    path={`paymentObligations[${key}]`}
                    paymentObligation={paymentObligation}
                    handleChange={handleChange}
                  />
                  {parseInt(key) < 5 && (
                    <>
                      <Grid sx={processCostSupportStyle.question} size={12}>
                        Haben Sie eine weitere Zahlungsverpflichtung/Kredit, den Sie abbezahlen?
                      </Grid>
                      <Grid
                        size={{
                          xs: 12,
                          md: 6,
                          lg: 4
                        }}>
                        <ValidatorSelect
                          label={"Weitere Zahlungsverpflichtung?"}
                          name={`hasMore-${key}`}
                          value={formValue(values, "paymentObligations").length - 1 > parseInt(key) ? "yes" : "no"}
                          onChange={handleMore}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={"no"}>Nein</MenuItem>
                          <MenuItem value={"yes"}>Ja</MenuItem>
                        </ValidatorSelect>
                      </Grid>
                    </>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default OtherPaymentObligations;
